module.exports = __webpack_public_path__ + "static/img/支付宝.6a478fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/支付宝.jpg
// module id = eIzG
// module chunks = 1